export const cleanBannerSet = bannerSetInfos => {
  // Deleting transient status info
  delete bannerSetInfos.uid;
  delete bannerSetInfos.lockOwner;
  delete bannerSetInfos.workspacePath;
  delete bannerSetInfos.permissions;

  return bannerSetInfos;
};
